import { Component, Input, ElementRef, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NmInput } from '../input/input';

declare let $: any;

export interface NmSelectOption {
	label: string,
	value: any,
	disabled?: boolean,
	parent?: string,
	visible?: boolean
}

@Component({
	selector: 'nm-select',
	templateUrl: './select.html',
	providers: [
		{
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: forwardRef(() => NmSelect),
	    multi: true,
	  }
  ]
})
export class NmSelect extends NmInput {
	@Input() options: NmSelectOption[] = [];
	@Input() multiple: boolean = false;
	@Input() placeholder: string = '(Please Choose)';
	@Input() value: any;
	@Output() onChanged = new EventEmitter<any>();

	public jsSelect: any;

	// initiate jquery chosen
	public ngAfterViewInit() {
		let self = this;
		super.ngAfterViewInit();

		let elem = self.elementRef.nativeElement;
		self.jsSelect = $(elem).find('.chzn-select');
		self.jsSelect.chosen({
			width: '100%',
			allow_single_deselect: true,
			search_contains: true
		});

		// trigger blur on change, because select dose not trigger blur
		self.jsSelect.change(function(event) {
			self._value = $(this).val();
			
			self.onInputChange(event);
			self.onInputTouched(event);
			self.onChanged.emit(self._value);
		});

		this._updateChosen();
	}

	// update chosen for async pipe
	public ngOnChanges() {
		if(this.jsSelect) {
			setTimeout(() => {
				this.jsSelect.trigger('chosen:updated');
			}, 10);
		}
	}

	// set initial value
	public writeValue(value: any): void {
		super.writeValue(value);
		this._updateChosen();
	}

	// writeValue not 100% work
	// because writeWalue runs before render
	// therefore before <select> being created, which cause jquery error
	private _updateChosen() {
		if(this.jsSelect && this.jsSelect.length > 0 && this._value) {
			this.jsSelect.val(this._value);
			this.jsSelect.trigger('chosen:updated');
		}
	}
}


// WEBPACK FOOTER //
// ./src/widgets/select/select.ts